<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import util from './utils/util'
	import config from './utils/config'
	import api from './utils/api'
	const mixinCom = require('./utils/mixin/mixinCom.js')
	uni.mixinCom = mixinCom
	// 引用阿里云arms sdk
	// #ifdef H5
	import armsRum, { setArmsUser } from './utils/sdk/ali-arms-web.js'
	// #endif
	// #ifndef H5
	import armsRum, { setArmsUser } from './utils/sdk/ali-arms-mini.js'
	// #endif

	export default {
		globalData: {  
			loginLog: {
				City: null, // 登录所在城市（需要请求用户授权获取手机定位）
				Province: null, // 登录所在省份（需要请求用户授权获取手机定位）
				Country: null, // 登录所在国家（需要请求用户授权获取手机定位）
				Language: null, // 浏览的语言风格
				ThirdAppType: 1, // 第三方登录凭证类型（剧汇王朝用户登录时为空） = ['微信小程序' = 1, '其他' = 999], 使用数值，避免变更名称后出错
				SourceType: '小程序', // 登陆渠道 = ['Web', '小程序', 'App', '微信公众号', '其它']
				DeviceType: 'CellPhone', // 登录设备类型 = ['PC', 'Pad', 'CellPhone']
				Sysetm: null, // 客户机系统类型
				SysVersion: null, // 客户机系统版本
				Platform: 'WeChat', // 产品寄宿的平台
				PFMVersion: null, // 产品寄宿的平台的版本
				ProductVersion: '0.0.1.1' // 产品版本与POMS版本一样
			},
			systemInfo: null,
			iyanyiUser: {
				UserId: undefined
			},
			userInfo: null,
			theaterInfo:{},
			temporaryOrder:{},
			orderData:{},
			likeType:'',
			isInWeiXinB: false, // 在微信内置浏览器
			wxConfig:{},        // 微信配置信息
			ChannelId:'', //渠道商id
			pxTorpx:2,//px转rpx的转换比例
			orderid:'',
		},
		onLaunch: function() {
			// console.log(this)
			console.log('App Launch');
			// 展示本地存储能力
			var logs = uni.getStorageSync('logs') || []
			logs.unshift(Date.now())
			uni.setStorageSync('logs', logs)

			// 必须在onshow之前赋值
			let wxMiniOpenId  = uni.getStorageSync('wxMiniOpenId')
			if(wxMiniOpenId){
				this.globalData.wxConfig.openId = wxMiniOpenId
			}
			console.log('wxMiniOpenId:',wxMiniOpenId)
			// #ifdef MP-WEIXIN
			var res = util.getSystemInfoSync()
			this.$store.dispatch('globalInfo/changeSystemInfo',res.systemInfo)
			this.$store.dispatch('globalInfo/changeLoginLog',res.loginLog)
			
			// 监察设备更新
			util.detectionUpdata()   
			// #endif
			// if(!this.checkPage('*')) // this.$router.addRoutes([{ path: '*', redirect: '/static/html/404.html'}])
		},
		onShow: function() {
			console.log('App Show')
			let iyanyiUser = uni.getStorageSync('iyanyiUser')
			let clientId = uni.getStorageSync('clientId')
			if(iyanyiUser){
				this.globalData.iyanyiUser = iyanyiUser
			}
			this.globalData.orderData = uni.getStorageSync('orderData')
			// #ifdef H5
			if(!clientId) {
				let tenantId = config.clientId
				tenantId = util.getCookie('tenantid') || config.clientId
				config.clientId = tenantId
				uni.setStorageSync('clientId', config.clientId)
			}
			// #endif
			// #ifndef H5
			uni.setStorageSync('clientId', config.clientId)
			// #endif
			// H5需要走这里
			// #ifdef H5
				// console.log('getTheaterInfo')
				// this.getTheaterInfo()
			this.checkBridge()
			this.checkNoPage()
			// #endif

			// #ifdef MP-WEIXIN
			//获取转换比例
			this.getPxToRpx()
			// #endif
			this.getCHN()
			this.getCountryPhone()
			
			// 设置ARMS用户ID
			try {
				if (iyanyiUser && iyanyiUser.Id) {
					setArmsUser(clientId+'-'+iyanyiUser.Id)
				}
			} catch (e) {}
		},
		onHide: function() {
			console.log('App Hide');
		},
		methods:{
			checkNoPage(){
				let path = this.$route.meta? this.$route.meta.pagePath : this.$route.path
				if(path === '/') path = 'pages/index/index'
				if(!this.checkPage(path)) window.location.href = '/static/html/404.html'
			},
			checkPage(page){
				let result = false
				this.$router.options.routes.forEach(rou=>{
					if(page === rou.meta.pagePath) result = true
				})
				return result
			},
			// 判断是否微信内置浏览器
			checkBridge(){
				if(util.isWeiXin()){
					console.log('加载微信js-sdk') // 加载微信js-sdk
					this.globalData.isInWeiXinB = true
					// util.loadJS('http://res.wx.qq.com/open/js/jweixin-1.6.0.js',function(){
					// 	wx.config({
					// 		debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					// 		appId: '', // 必填，公众号的唯一标识
					// 		timestamp: '', // 必填，生成签名的时间戳
					// 		nonceStr: '', // 必填，生成签名的随机串
					// 		signature: '',// 必填，签名
					// 		jsApiList: [] // 必填，需要使用的JS接口列表
					// 	});
					// })
				} else {
					this.globalData.isInWeiXinB = false
				}
			},
			getSeatBaseInfo (params={}) {
				let that = this
				let url = api.getSeatBaseInfoV3
				// let params = {}
				return new Promise((resolve, reject) => {
					let dataInfo = uni.getStorageSync('seat_base_info')
					let tenantId =  (uni.getStorageSync('clientId') || config.clientId) + '-'+ params.showTimeId
					let nowTimer = new Date().getTime()
					if(dataInfo && dataInfo.timer && dataInfo.info && (dataInfo.tenantId === tenantId) && (nowTimer-dataInfo.timer < 1*3600*1000)){
						resolve(dataInfo.info)
					} else {
						util.postData.call(this,url,params,'GET',function(res){
							dataInfo = {
								timer: new Date().getTime(),
								info: res.data.data,
								tenantId:tenantId,
							}
							uni.setStorageSync('seat_base_info',dataInfo)
							resolve(res.data.data)
						},function(res){
							reject(res)
						})
					}
				})
			},
			// 获取会员查询信息Id
			getMemberDetailId () {
				let that = this
				let url = api.userMemberGetC2
				let params = {}
				return new Promise((resolve, reject) => {
					let dataInfo = uni.getStorageSync('member_info_id')
					let tenantId =  uni.getStorageSync('clientId') || config.clientId
					let nowTimer = new Date().getTime()
					if(dataInfo && dataInfo.timer && dataInfo.info && (dataInfo.tenantId === tenantId) && (nowTimer-dataInfo.timer < 30*1000)){
						resolve(dataInfo.info)
					} else {
						util.postData.call(this,url,params,'GET',function(res){
							dataInfo = {
								timer: new Date().getTime(),
								info: res.data.data,
								tenantId:tenantId,
							}
							uni.setStorageSync('member_info_id',dataInfo)
							resolve(res.data.data)
						},function(res){
							reject(res)
						})
					}
				})
			},

			// 获取会员查询信息
			getMemberDetail () {
				let that = this
				let url = api.userMemberInfoC
				let params = {}
				return new Promise((resolve, reject) => {
					let dataInfo = uni.getStorageSync('member_info')
					let tenantId =  uni.getStorageSync('clientId') || config.clientId
					let nowTimer = new Date().getTime()
					if(dataInfo && dataInfo.timer && dataInfo.info && (dataInfo.tenantId === tenantId) &&(nowTimer-dataInfo.timer < 30*1000)){
						resolve(dataInfo.info)
					} else {
						util.postData.call(this,url,params,'GET',function(res){
							dataInfo = {
								timer: new Date().getTime(),
								info: res.data.data,
								tenantId:tenantId,
							}
							uni.setStorageSync('member_info',dataInfo)
							resolve(res.data.data)
						},function(res){
							reject(res)
						})
					}
				})
			},

			getHomeTitleList () {
				let that = this
				let url = api.getTitleList
				let params = {}
				return new Promise((resolve, reject) => {
					let dataInfo = uni.getStorageSync('titleList_info')
					let tenantId =  uni.getStorageSync('clientId') || config.clientId
					let nowTimer = new Date().getTime()
					if(dataInfo && dataInfo.timer && dataInfo.info && (dataInfo.tenantId === tenantId) &&(nowTimer-dataInfo.timer < 30*1000)){
						resolve(dataInfo.info)
					} else {
						util.postData.call(this,url,params,'GET',function(res){
							dataInfo = {
								timer: new Date().getTime(),
								info: res.data.data,
								tenantId:tenantId,
							}
							uni.setStorageSync('titleList_info',dataInfo)
							resolve(res.data.data)
						},function(res){
							reject(res)
						})
					}
				})
			},

			getTheaterInfo(){
				let that = this
				let url = api.getTheaterInfo
				let params = {}
				return new Promise((resolve, reject) => {
					let theaterInfo = uni.getStorageSync('theater_info')
					let tenantId =  uni.getStorageSync('clientId') || config.clientId
					let nowTimer = new Date().getTime()
					if(theaterInfo && theaterInfo.timer && theaterInfo.info && (theaterInfo.tenantId === tenantId) && (nowTimer-theaterInfo.timer < 1* 3600*1000)){
						that.globalData.theaterInfo = theaterInfo.info
						if(that.userInfoReadyCallback){
							that.userInfoReadyCallback(theaterInfo.info)
						}
						resolve(theaterInfo.info)
					} else {
						util.postData.call(this,url,params,'GET',function(res){
							let newData = {}
							if(res.data) newData = res.data.data || {}
							theaterInfo = {
								timer: new Date().getTime(),
								info: newData,
								tenantId:tenantId,
							}
							uni.setStorageSync('theater_info',theaterInfo)
							that.globalData.theaterInfo = res.data.data
							if(that.userInfoReadyCallback){
								that.userInfoReadyCallback(res.data.data)
							}
							resolve(res.data.data)
						},function(res){
							reject(res)
						})
					}
				})
			},

			getPxToRpx(){
				uni.getSystemInfoSync({
					success:(res)=>{
						let screenWidth = res.screenWidth
						this.globalData.pxTorpx = 750/screenWidth
					}
				})
			},

			getCHN(params){
				let url = 'https://static.52drama.com/common/CHN.json'
				return new Promise((resolve, reject) => {
					util.requestData(url,params,'get').then(res=>{
						config.CHN = res
						resolve(res)
					}).catch(err =>{
						reject(err)
					})
				})
				
			},
			getCountryPhone(params){
				let url = 'https://static.52drama.com/common/CountryPhone.json'
				return new Promise((resolve, reject) => {
					util.requestData(url,params,'get').then(res=>{
						config.countryPhoneJson = res || {}
						resolve(res)
					}).catch(err =>{
						reject(err)
					})
				})
				
			},

		}
	}
</script>

<style lang="scss">
	/* 头条小程序需要把 iconfont 样式放到组件外 */
	@import "components/m-icon/m-icon.css";

	@import './style/iconfont.css';
	@import './style/flex-ui.css';
	@import './style/iconfont-color.css';
	/* IYanYi样式*/
	@import "./style/index.scss";
	/*每个页面公共css */
	page {min-height:100%;display:flex;font-size:16px;background:#f4f4f4;}

	/* #ifdef MP-BAIDU */
	page {width:100%;height:100%;display:block;}
	swan-template {width:100%;min-height:100%;display:flex;}

	/* 原生组件模式下需要注意组件外部样式 */
	custom-component {width:100%;min-height:100%;display:flex;}
	/* #endif */

	/* #ifdef MP-ALIPAY */
	page {min-height:100vh;}
	/* #endif */

	.container{width: 100%;overflow: hidden;}
	.clear {clear:both; height:0; font-size:0; line-height:0; overflow:hidden;}
	.cle:after {visibility:hidden; display:block; font-size:0; content:'\20'; clear:both; height:0;}
	.clearfix:after{visibility:hidden; display:block; font-size:0; content:'\20'; clear:both; height:0;}
	.clear_f:after{visibility:hidden; display:block; font-size:0; content:'\20'; clear:both; height:0;}
	.cle_float:after{visibility:hidden; display:block; font-size:0; content:'\20'; clear:both; height:0;}

	.f-l{float: left;}
	.f-r{float: right;}

	.blue-btn{padding: 10rpx;background: #84d9d4;border-radius: 50rpx;margin: 10rpx auto;width:200rpx;}
	.text-c{text-align: center}
	.text-l{text-align: left}
	.text-r{text-align: right}

	/* 原生组件模式下需要注意组件外部样式 */
	m-input {width:100%;/* min-height:100%;*/display:flex;flex:1;}
	.content {display:flex;flex:1;flex-direction:column;padding:10px;}
	.input-group {background-color:#ffffff;margin-top:20px;position:relative;}
	.input-group::before {position:absolute;right:0;top:0;left:0;height:1px;content:'';-webkit-transform:scaleY(.5);transform:scaleY(.5);background-color:#c8c7cc;}
	.input-group::after {position:absolute;right:0;bottom:0;left:0;height:1px;content:'';-webkit-transform:scaleY(.5);transform:scaleY(.5);background-color:#c8c7cc;}
	.input-row {display:flex;flex-direction:row;position:relative;font-size:18px;line-height:40px;}
	.input-row .title {width:72px;padding-left:15px;}
	.input-row.border::after {position:absolute;right:0;bottom:0;left:8px;height:1px;content:'';-webkit-transform:scaleY(.5);transform:scaleY(.5);background-color:#c8c7cc;}
	.btn-row {margin-top:25px;padding:10px;}
	button.primary {background-color:#0faeff;}
	
	view,scroll-view,swiper,swiper-item,cover-view,cover-image,icon,text,rich-text,progress,button,checkbox,form,input,label,radio,slider,switch,textarea,navigator,audio,camera,image,video {box-sizing:border-box;}
</style>